export default function monthsFromNow(today, selectedExpirationMonth) {
  if (!today) {
    throw new TypeError(`monthsFromNow expects a date. got ${typeof today}`);
  }

  if (!selectedExpirationMonth) {
    return '';
  }

  const currentMonth = today.getMonth() + 1;
  const difference = selectedExpirationMonth - currentMonth;

  if (difference === 1) {
    return '13 / 1 months';
  }

  if (difference === 2) {
    return '14 / 2 months';
  }

  if (difference === 3) {
    return '15 / 3 months';
  }

  if (difference > 3) {
    return `${difference} months`;
  }

  if (selectedExpirationMonth <= currentMonth) {
    return `${(selectedExpirationMonth + 12) - currentMonth} months`;
  }
}



// WEBPACK FOOTER //
// ./src/modules/monthsFromNow.js